import * as React from "react";
import { AppContext } from "pages/app/duck/context";

/**
 * Sets the error flag in the {@link AppContext}  if an error page has appeared.
 *
 */
const useErrorPage = (): void => {
  const { setErrorPage } = React.use(AppContext);

  React.useEffect(() => {
    setErrorPage(true);
    return () => setErrorPage(false);
  }, []);
};

export default useErrorPage;
